import React from 'react'

import { sourceLogo } from '../assets'
import {
  Icon,
  ModuleCard,
  ModuleDescription,
  ModuleIcon,
  ModuleList,
  ModuleTitle,
  SourceLogo,
  ToolBadge,
} from '../Overview/styled'

export default function ProjectModuleCard({ module, renderIcon, research }) {
  return (
    <ModuleCard>
      <ModuleIcon type={module.key} logo={research}>
        {research ? <SourceLogo src={sourceLogo(module.key)} alt="" /> : module.key === 'social' ? (
          <>
            <SourceLogo src={sourceLogo('linkedin')} alt="LinkedIn" compact />
            <SourceLogo src={sourceLogo('instagram')} alt="Instagram" compact />
          </>
        ) : <Icon viewBox="0 0 24 24">{renderIcon(module.key)}</Icon>}
      </ModuleIcon>
      <ModuleTitle>{module.title}</ModuleTitle>
      <ModuleDescription>{module.description}</ModuleDescription>
      <ModuleList>{module.findings.map(item => <li key={item}>{item}</li>)}</ModuleList>
      {module.tools?.length ? (
        <div>{module.tools.map(tool => <ToolBadge key={tool} tool={tool}>{tool}</ToolBadge>)}</div>
      ) : null}
    </ModuleCard>
  )
}
